export default function () {
  $('.js-acrdn').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    if($(this).prev().hasClass('c-btn--toggle')) {
      $(this).prev().toggleClass('is-active');
    }
    let target = $(this).attr('data-target');
    let $u = $(this).closest('.js-acrdn-unit');
    $u.find(target).slideToggle(350);
    setTimeout(function() {
      $u.find(target).toggleClass('is-active');
    }, 150)
  });

  $('.js-acrdn-singleton').on('click', function(e) {
    e.preventDefault();
    let target = $(this).attr('data-target');
    let $u = $(this).closest('.js-acrdn-unit-singleton');
    let $other = $('.js-acrdn-unit-singleton').not($u);

    $other.find('.u-hide').slideUp(350);
    $other.find('.js-acrdn-singleton').removeClass('is-active');

    if( $(this).hasClass('is-active') ) {
      $(this).removeClass('is-active');
      $u.find(target).removeClass('is-show').slideUp(350);
    } else {
      $(this).addClass('is-active');
      $u.find(target).addClass('is-show').slideDown(350);
    }
  });
}
